import type { ItemSelect_ItemFragment } from "../ItemSelect.generated.js";
import { MoveToSubMenuItem } from "./MoveToSubMenuItem.js";

interface Props {
  getValidMoveTargets: () => Promise<ItemSelect_ItemFragment[]>;
  onMoveItems: (targetItemId: string) => void | Promise<void>;
  onMoved?: () => void;
}

export const DocItemContextMenuBatchItems = ({
  getValidMoveTargets,
  onMoveItems,
  onMoved,
}: Props) => {
  return (
    <MoveToSubMenuItem
      getValidMoveTargets={getValidMoveTargets}
      onMove={onMoveItems}
      onMoved={onMoved}
    />
  );
};
